// Cover-design + illustration sample tile images for the Post a Project galleries.
//
// The gallery submits BACKEND-LEGIBLE filenames (cover_sample_<n>.png /
// illustration_sample_<n>.png, n = 0..29) so the persisted picks render through
// CoverDesignSamplesComponent / IllustrationSamplesComponent on order pages and
// freelancer requirement panels (Plumbline bug 1). The real PNGs live in the
// Rails asset tree (app/assets/images/{cover,illustration}_samples); Vite bundles
// them here as hashed URLs so the tiles are SIGHTED instead of blank striped
// placeholders (Plumbline bug 3).

const coverModules = import.meta.glob(
  "../../../assets/images/cover_samples/*.png",
  { eager: true, query: "?url", import: "default" }
)

const illustrationModules = import.meta.glob(
  "../../../assets/images/illustration_samples/*.png",
  { eager: true, query: "?url", import: "default" }
)

// { "cover_sample_0.png": "/vite/assets/cover_sample_0.<hash>.png", ... }
function toMap(modules) {
  const out = {}
  for (const path in modules) {
    const name = path.split("/").pop()
    out[name] = modules[path]
  }
  return out
}

export const COVER_SAMPLE_URLS = toMap(coverModules)
export const ILLUSTRATION_SAMPLE_URLS = toMap(illustrationModules)

// The colour palette images (app/assets/images/color_palettes), keyed by the
// backend palette key: { "greens": "/vite/assets/greens.<hash>.png", ... }.
const paletteModules = import.meta.glob(
  "../../../assets/images/color_palettes/*.png",
  { eager: true, query: "?url", import: "default" }
)

export const COLOR_PALETTE_URLS = Object.fromEntries(
  Object.entries(toMap(paletteModules)).map(([name, url]) => [name.replace(/\.png$/, ""), url])
)
